
import ShowMoreButton from '~/components/elements/ShowMoreButton';
import Pagination from '~/components/elements/Pagination';

export default {
  name: 'CustomPagination',
  components: { Pagination, ShowMoreButton },
  props: {
    count: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    preloader: {
      type: Boolean,
      default: false,
    },
    pageParam: {
      type: String,
      default: 'page',
    },
    isShowMore: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    pagesCount() {
      return Math.ceil(this.count / this.perPage)
    },
  },
  methods: {
    onShowMore() {
      this.$emit('selected', { [this.pageParam]: this.currentPage + 1 })
    },
    pageSelectedHandler(selected) {
      this.$emit('selected', { [this.pageParam]: selected })
    },
  },
}
